import React from "react";
import {DropdownButton, Dropdown, Tabs, ProgressBar} from "react-bootstrap";
import "../../styles/Views.css"
import axios from "axios";
import {API} from "../../service/api";
import {Inspector, Runtime} from "@observablehq/runtime";
import pieChart1 from "../@d3/PieChartRate";
import ExplanationNote from "./ExplanationNote";
import circleLegend1 from "../@d3/CircleLegendRate";

const StatsView = () =>{
    const cid = sessionStorage.getItem("cid")
    const [qid, SelectQid] = React.useState("course");
    const [title, SetTitle] = React.useState("Select Question");

    const handleQuestionSelect = (e) =>{
        SelectQid(e)
        SetTitle(e)
    }

    const qidMap = {"course":"Overall, this course was excellent (5-point scale).",
    "instructor": "Overall, this instructor was an effective teacher (5-point scale)."}

    const explanations = {"scale": ["View 5-point Likert Scale Details", "The rating is based on a 5-point Likert scale:\n" +
        "5 = Strongly Agree, 4 = Agree, 3 = Neither agree nor disagree, 2 = Disagree, 1 = Strongly Disagree;"]}

    // rates bar chart
    const [loading, setLoading] = React.useState(true);
    const [bars, setBars] = React.useState(JSON.parse(sessionStorage.getItem("PieCR")));
    const [totalNum, setTotalNum] = React.useState(0);
    const [avgRate, setAvgRate] = React.useState(0);

    React.useEffect(() =>{
        setLoading(true);
    }, [qid])

    React.useEffect(()=>{
        axios.get(`${API}/QuantRates/${cid}`).then((response)=>{
                // let rates = response.data.crate
                let ratelist = response.data.cratefull
                switch (qid){
                    case 'course':
                        ratelist = response.data.cratefull;
                        break;
                    case 'instructor':
                        ratelist = response.data.iratefull;
                        break
                }

                // setCrateAvg(Array.from(ratelist).reduce((previousValue, currentValue) => previousValue + currentValue,0))
                let PieRate = [{"name": "5", "value": Array.from(ratelist).filter(item => item==5).length},
                    {"name": "4", "value": Array.from(ratelist).filter(item => item==4).length},
                    {"name": "3", "value": Array.from(ratelist).filter(item => item==3).length},
                    {"name": "2", "value": Array.from(ratelist).filter(item => item==2).length},
                    {"name": "1", "value": Array.from(ratelist).filter(item => item==1).length}]
                // let PieRate = [{"name":"Negative","value":rates[1]},{"name":"Positive","value":rates[0]}]
                sessionStorage.setItem("PieRate", JSON.stringify(PieRate));
                setBars(PieRate)
                setTotalNum(Array.from(ratelist).length)
                setAvgRate(Math.round(Array.from(ratelist).reduce((prev, cur) => prev + cur, 0)/response.data.total*10)/10)
              }).catch((error) =>{
                console.log(error)
              }).finally(()=>{
                  setLoading(false);
            })
    },[qid])

    // circle legend rates
    const circleRef1 = React.useRef();
    const [loadCircle, setLoadCircle] = React.useState(true);

    function capitalize(s)
    {
        return s[0].toUpperCase() + s.slice(1);
    }

    React.useEffect(()=>{
        // CircleLegendCourseRate data
              axios.get(`${API}/${capitalize(qid)}Stats/${cid}`).then((response)=> {
                  let courseStats = response.data.data
                  const circleLegendCourseRate = {
                      tickValues: [100, parseInt(courseStats[1] / courseStats[0] * 100)],
                      data: [courseStats[0], courseStats[1]]
                  }
                  sessionStorage.setItem("CircleRate", JSON.stringify(circleLegendCourseRate));
              }).catch((error)=>{
                  console.log(error)
              }).finally(()=>{
                  setLoadCircle(false)
              })
    }, [qid])

    React.useEffect(() =>{
        if(!loadCircle){
            const runtime = new Runtime();
            runtime.module(circleLegend1, Inspector.into(circleRef1.current));
            return () => runtime.dispose();
        }
    }, [loadCircle])

    // pie chart rates
    const pieRef1 = React.useRef();

    React.useEffect(()=>{
        if(!loading){
            const runtime = new Runtime();
            runtime.module(pieChart1, Inspector.into(pieRef1.current));
            return () => runtime.dispose();

        }
    }, [loading])

    return(
        <div className={"viewbox"}>
            <div className={"nav-top"}>
                <DropdownButton id="dropdown-basic-button" title={title} onSelect={handleQuestionSelect}>
                  <Dropdown.Item eventKey={"course"}>Overall, this course was excellent (5-point scale).</Dropdown.Item>
                  <Dropdown.Item eventKey={"instructor"}>Overall, this instructor was an effective teacher (5-point scale).</Dropdown.Item>
                </DropdownButton>

            </div>

            <h3 style={{paddingTop: "0.5em"}}>Q: {qidMap[qid]}</h3>
            <div v style={{paddingLeft: "20vw", paddingRight:"20vw"}}>
                <ExplanationNote data={explanations["scale"]} />
            </div>
            {(!loading && bars!=null && totalNum!=0 && avgRate !=0)?<div className={"scale-box"}>
                <div style={{width: "40vw"}}>
                    {Array.from(bars).map((item, i) => (
                        <div className={"scale-plot"}>
                            <div className={"scale-number"}>{item.name}</div>
                            <ProgressBar now={item.value} className={"scale-bar"}/>
                            <div className={"scale-number"}>{Math.round(item.value/totalNum*100)}%</div>
                        </div>
                    ))}
                </div>
                <div>
                    <div style={{fontSize: "2em"}}>{avgRate}</div>
                    <div>Average Rating</div>
                    <div style={{textAlign: "left", paddingLeft: "1em", color: "gray"}}>{totalNum} number of student ratings</div>
                </div>
            </div>:<div>loading...</div>}

            <div className={"row-block"}>
                <div className={"sub-block"} style={{width: "50vw", height: "50vh"}}>
                            <h5>Response Rate</h5>
                            <div style={{height: "5vh"}}></div>
                            <div style={{display: "flex", textAlign: "left", width: "30vw"}}>
                                {loadCircle?<div>loading...</div>:<div ref={circleRef1}></div>}
                            </div>
                            {/*<ul style={{paddingTop: "1em"}}>*/}
                            {/*    <li>Out of 283 total reviews, 113 of the reviews had non-empty submissions</li>*/}
                            {/*</ul>*/}
                </div>

                <div className={"sub-block"} style={{width: "40vw", height: "50vh"}}>
                            <h5>Ratings in Pie Chart</h5>
                            {/*<p style={{fontSize: "0.5em", textAlign: "left"}}>The rating is based on a <b>5-point Likert scale</b>:*/}
                            {/*    <br />5 = Strongly Agree, 4 = Agree, 3 = Neither agree nor disagree, 2 = Disagree, 1 = Strongly Disagree;*/}
                            {/*    </p>*/}
                            {/*<br /><b>Sentiment</b>: Positive: (5 and 4); Negative: (3, 2, and 1)*/}
                            <div style={{width: "30vw", paddingTop: "5vh"}}>
                                {loading?<div>loading...</div>:<div ref={pieRef1}></div>}
                            </div>
                </div>
            </div>

        </div>
    )
}

export default StatsView;